import $appState from '../services/app-state';

export default Vue => {
  Vue.appState = Vue.observable($appState);
  Object.defineProperties(Vue.prototype, {
    $appState: {
      get: () => Vue.appState,
    },
  });
};
